import {
  jb_teaser_meta_css_default
} from "./chunk.5AOJGQFX.js";
import {
  Linkable
} from "./chunk.3FKBYJ4V.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-teaser-meta/jb-teaser-meta.ts
var JbTeaserMeta = class extends Linkable(r) {
  _renderDate() {
    if (this.date) {
      return ke`<div class="date"><jb-calendar-icon></jb-calendar-icon><jb-date date=${this.date}></jb-date></div>`;
    }
    return null;
  }
  _renderTime() {
    if (this.time) {
      return ke`<jb-time time=${this.time}></jb-time>`;
    }
    return null;
  }
  _renderTimeZone() {
    if (this.timeZone) {
      return ke`<div class="timezone">
        <jb-globe-icon></jb-globe-icon>
        ${this.timeZone}
      </div>`;
    }
    return null;
  }
  render() {
    return ke`
      <div class="info">${this._renderDate()} ${this._renderTime()} ${this._renderTimeZone()}</div>
      ${this.category && ke`<jb-navigation-tags
        .activeItem=${this.category}
        .items=${[{ tag: this.category, link: this.link }]}
        class="category"
      ></jb-navigation-tags>`}
    `;
  }
};
JbTeaserMeta.styles = [reset_css_default, jb_teaser_meta_css_default];
__decorateClass([
  n()
], JbTeaserMeta.prototype, "category", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "date", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "time", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "timeZone", 2);
JbTeaserMeta = __decorateClass([
  customElement("jb-teaser-meta")
], JbTeaserMeta);

export {
  JbTeaserMeta
};
